import { Api } from "./axios-config";


const getAll = async (filter = ''): Promise< string> => {
  try {
    const urlRelativa = `/colhedorcpf/${filter}`;   
    const { data } = await Api.get(urlRelativa);
    if (data && typeof data === 'string') { 
      return data; 
    }
    throw new Error('Erro ao listar os registros ou dados inválidos.');
  } catch (error) {
    throw new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const CpfService = {
  getAll,
};